import { ref, onMounted, onUnmounted } from "vue";

export function useEliminatedFromBBB() {
    localStorage.setItem('verEliminados', false);

    onMounted(() => window.addEventListener('storage', handleLocalStorageChange));

    onUnmounted(() => window.removeEventListener('storage', handleLocalStorageChange));

    const handleLocalStorageChange = (event) => {
        isShowing.value = event.newValue === 'true';
    };

    const isShowing = ref(localStorage.getItem('verEliminados') === 'true');

    return { isShowing };
}
